// Centralised native-platform helpers.
//
// The same React bundle runs in three contexts:
//   1. Browser (PWA / desktop / mobile web)   → all features available
//   2. Capacitor iOS                          → must hide in-app purchase
//                                                buttons to satisfy Apple's
//                                                "reader app" guideline
//   3. Capacitor Android                      → same restriction now applied
//                                                by Google Play (Aug 2024+)
//
// Anything that needs to branch on platform must go through these helpers
// so the rules stay in one place.

import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
export const isIOS = () => platform() === "ios";
export const isAndroid = () => platform() === "android";

/**
 * Whether the current build is allowed to show purchase / upgrade buttons
 * INSIDE the app. We deliberately disable this on every native build so
 * Apple/Google reviewers never see a checkout flow that would route money
 * outside their stores. Users are pointed to keepsoul.app to subscribe.
 */
export const canShowPurchaseUI = () => !isNative();

/**
 * URL the user must visit (from a native build) to upgrade their plan.
 * Always the production marketing site so the link works the same whether
 * the app is opened from TestFlight, App Store or Google Play.
 */
export const WEB_BILLING_URL = "https://keepsoul.app/plans";
